export default __webpack_public_path__ + "static/media/gifty-logo-black.4e938609.svg";